import * as moment from "moment";
import "moment-timezone";

export const DEFAULT_TIMEZONE = moment.tz.guess();

export const IS_TIMEZONE_INDIA =
  moment.tz.guess().includes("Kolkata") ||
  moment.tz.guess().includes("Calcutta");
